import { render } from "./ArgonProgressWithAlert.vue?vue&type=template&id=799bd004"
import script from "./ArgonProgressWithAlert.vue?vue&type=script&lang=js"
export * from "./ArgonProgressWithAlert.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__